var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeaChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.97501C2 3.33196 3.34315 2 5 2H19C20.6569 2 22 3.33196 22 4.97501V15C22 16.6431 20.6569 17.975 19 17.975H6L3.78087 20.6259C3.19036 21.3578 2 20.9438 2 20.0064V4.97501ZM13.8374 12.4925C13.8374 12.0949 14.0757 11.7428 14.4085 11.5254C15.5424 10.7844 16.2871 9.53476 16.2871 8.11809C16.2871 5.84373 14.3677 4 12 4C9.6323 4 7.71289 5.84373 7.71289 8.11809C7.71289 9.53476 8.45761 10.7844 9.59151 11.5254C9.92428 11.7428 10.1627 12.0949 10.1627 12.4925C10.1627 12.7728 10.3899 13 10.6702 13H13.3298C13.6101 13 13.8374 12.7728 13.8374 12.4925ZM10.25 14.9997C10.25 15.4139 10.5858 15.7497 11 15.7497H13C13.4142 15.7497 13.75 15.4139 13.75 14.9997C13.75 14.5854 13.4142 14.2497 13 14.2497H11C10.5858 14.2497 10.25 14.5854 10.25 14.9997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaChat);
export default __webpack_public_path__ + "static/media/idea-chat.e03ec3fcadef57fe2df648df13523ce1.svg";
export { ForwardRef as ReactComponent };